import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { BedroomsOfferState } from './types'

const INITIAL_STATE: BedroomsOfferState = {
  error: '',
  list: [],
  loading: false,
  request_totals: {
    total_emissions: 0,
    total_quotations: 0
  },
  sendBedroomsOfferError: '',
  sendBedroomsOfferLoading: false,
  total_results: 0
}

const reducer = createReducer<BedroomsOfferState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getBedroomsOffer, state => ({
    ...state,
    error: '',
    loading: true
  }))
  .handleAction(Actions.getBedroomsOfferFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    loading: false
  }))
  .handleAction(Actions.getBedroomsOfferSuccess, (state, { payload }) => ({
    ...state,
    list: [...payload.agency_partner_hotel_offers],
    loading: false
  }))
  .handleAction(Actions.sendBedroomsOffer, state => ({
    ...state,
    sendBedroomsOfferError: '',
    sendBedroomsOfferLoading: true
  }))
  .handleAction(Actions.sendBedroomsOfferFailure, (state, { payload }) => ({
    ...state,
    sendBedroomsOfferError: payload.message,
    sendBedroomsOfferLoading: false
  }))
  .handleAction(Actions.sendBedroomsOfferSuccess, state => ({
    ...state,
    sendBedroomsOfferLoading: false
  }))

export default reducer
